import { CircularLoader } from '@modules/common/components/CircularLoader';
import { getEmojiFromDashboard } from '@modules/dashboard/helpers';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { DashboardListItemViewFragment } from 'generated/graphql';
import { CreateNewDashboardTemplatePreviewContent } from './CreateNewDashboardTemplatePreviewContent';
import { UseTemplateButton } from './UseTemplateButton';

interface CreateNewDashboardTemplatePreviewProps {
  isLoadingTemplates: boolean;
  selectedTemplate?: DashboardListItemViewFragment;
}

export const CreateNewDashboardTemplatePreview = ({
  isLoadingTemplates,
  selectedTemplate,
}: CreateNewDashboardTemplatePreviewProps) => {
  if (isLoadingTemplates) {
    return (
      <Stack spacing={2} pt={6} height="100%">
        <Stack spacing={2} px={6}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Skeleton variant="text" width={30} height={60} />
            <Skeleton variant="text" width={200} height={60} />
          </Stack>
          <Skeleton variant="text" width="60%" height={30} />
        </Stack>
        <Box px={6} overflow="auto" height="100%">
          <CircularLoader />
        </Box>
      </Stack>
    );
  }

  if (!selectedTemplate) {
    return (
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <Typography variant="h6" color="text.disabled">
          No template selected
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={2} py={6} height="100%">
      <Stack px={6} direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h6">
            {getEmojiFromDashboard(selectedTemplate)}
          </Typography>
          <Typography variant="h6">{selectedTemplate.title}</Typography>
        </Stack>
        <UseTemplateButton template={selectedTemplate} />
      </Stack>
      <QueryBuilderStoreProvider>
        <CreateNewDashboardTemplatePreviewContent
          selectedTemplate={selectedTemplate}
        />
      </QueryBuilderStoreProvider>
    </Stack>
  );
};
